import { render, staticRenderFns } from "./incident.vue?vue&type=template&id=41f988cc&scoped=true"
import script from "./incident.vue?vue&type=script&lang=js"
export * from "./incident.vue?vue&type=script&lang=js"
import style0 from "./incident.vue?vue&type=style&index=0&id=41f988cc&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41f988cc",
  null
  
)

export default component.exports